import React from 'react'

export const Products = () => {
  return (
    <section className="products" aria-label="Proxium Product Showcase">
      <div className="auto__container">
        <div className="products__inner">
          <div className="products__inner-image">
            <img
              src="/images/products/product-image-02.jpg"
              alt="Proxium hair care solution bottle"
            />
          </div>
          <div className="products__inner-image">
            <img
              src="/images/products/product-image-01.jpg"
              alt="Proxium advanced treatment product"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
